import { render } from "./_Index.vue?vue&type=template&id=c387b098&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=c387b098&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c387b098"

export default script